export default "__VITE_ASSET__DtAJ4a5I__"